<template>
  <div class="app-nav d-flex justify-space-around pa-2 ">
    <router-link v-for="navs in subNavRoutes" :key="navs.to" :to="navs.to" exact>
      <div class="home d-flex flex-column justify-center">
        <div class="text-center">
          <v-icon color="primary">
              {{navs.icon}}
          </v-icon>
        </div>
        <div class="nav-text">{{navs.title}}</div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
    props:{
        subNavRoutes:{
            type:Array
        }
    },
    mounted(){
      console.log("sub nav is working now")
  },
};
</script>

<style lang="scss" scoped>
a {
  display: block;
  text-decoration: none;
  filter: grayscale(100%);
}
a.router-link-active {
  filter: grayscale(0%);
}

a.router-link-active .nav-text {
  color: var(--red) !important;
}

.app-nav {
  background: #fff;
  border-top: 1px solid rgba(0, 0, 0, 0.075);
  .nav-text {
    font-size: 12px;
    line-height: 16px;
    color: #acacac !important;
  }
}
</style>
